module.exports = __webpack_public_path__ + "static/img/logo144.2284660.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo144.jpg
// module id = 9GXA
// module chunks = 1